import { useState } from 'react';
import { FETCH_STATUS } from '@hooks/useSWRFetch/types';
import { CreateUnassociatedVideoExportRequest__Output } from '@generated/grpc/spotify/s4mpview/v1';

export const useUnassociatedVideosExportRequest = () => {
  const [status, setStatus] = useState<FETCH_STATUS>(FETCH_STATUS.IDLE);

  const s4mpUnassociatedVideoExport = async (
    createCatalogExportDetails: CreateUnassociatedVideoExportRequest__Output,
  ) => {
    setStatus(FETCH_STATUS.FETCHING);
    try {
      const res = await fetch('/catalog/api/unassociatedvideosexportrequest', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(createCatalogExportDetails),
      });
      setStatus(FETCH_STATUS.SUCCESS);
      if (!res.ok) {
        setStatus(FETCH_STATUS.ERROR);
        return false;
      }
      return res.ok;
    } catch (error) {
      setStatus(FETCH_STATUS.ERROR);
      return false;
    }
  };

  return {
    status,
    actions: {
      s4mpUnassociatedVideoExport,
    },
  };
};
